import React from "react";
import Page, { PageProps } from "../Page";
import PasswordChangeForm from "./PasswordChangeForm";
import Text from "antd/lib/typography/Text";
import { IChangePasswordPresenter } from "../../../presenter/authentication/ChangePasswordPresenter";

export interface Props extends PageProps {}
export interface State extends IChangePasswordPresenter {}

export default class PasswordChangePage extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe(result => {
      return this.setState(prevState => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    let {
      translate,
      passwordPresentationModel,
      setPasswordValue,
      isChangeButtonDisabled,
      changePassword,
      validationPasswordErrors,
      username,
      showLogin
    } = this.state;

    return (
      <Page
        {...this.props}
        style={{
          display: "flex",
          justifyContent: "center",
          height: "100%",
          width: "100%",
          flexDirection: "column",
          alignItems: "center"
        }}
      >
        <Text style={{ fontSize: 30, color: "#8D8D8D", fontWeight: "bold" }}>
          {`${translate("change_password.title")} ${username}`}
        </Text>
        <PasswordChangeForm
          password={passwordPresentationModel}
          translate={translate}
          setPasswordValue={setPasswordValue}
          disableButton={isChangeButtonDisabled}
          changePassword={changePassword}
          validationErrors={validationPasswordErrors}
          isPasswordExpired={true}
          goBack={showLogin}
          loading={this.state.loaders.changePasswordLoader}
        />
      </Page>
    );
  }
}
